function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.841187,
  width: 60,
  height: 60,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1554_1298)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.5912 37.5V22.5H28.3412V37.5H26.5912ZM33.3412 37.5V22.5H35.0912V37.5H33.3412ZM30.8412 54.25C25.8829 54.25 21.4454 52.9375 17.5287 50.3125C13.612 47.6875 10.5495 43.9792 8.34119 39.1875V49.25H6.59119V36.25H19.5287V38H9.77869C11.6537 42.4583 14.4662 45.9896 18.2162 48.5938C21.9662 51.1979 26.1745 52.5 30.8412 52.5C35.8412 52.5 40.3204 50.9896 44.2787 47.9688C48.237 44.9479 50.9245 41.0417 52.3412 36.25L54.0912 36.5625C52.6329 41.8542 49.7579 46.125 45.4662 49.375C41.1745 52.625 36.2995 54.25 30.8412 54.25ZM6.71619 27.5C7.04952 24.9583 7.61202 22.7292 8.40369 20.8125C9.19535 18.8958 10.3829 16.875 11.9662 14.75L13.2787 15.9375C11.9454 17.6875 10.9245 19.4167 10.2162 21.125C9.50785 22.8333 8.92452 24.9583 8.46619 27.5H6.71619ZM16.7787 12.5L15.5912 11.1875C17.5495 9.6875 19.6016 8.5 21.7474 7.625C23.8933 6.75 26.0912 6.20833 28.3412 6V7.75C26.3412 7.95833 24.3516 8.46875 22.3724 9.28125C20.3933 10.0938 18.5287 11.1667 16.7787 12.5ZM44.7787 12.5C43.3204 11.25 41.5183 10.1875 39.3724 9.3125C37.2266 8.4375 35.2162 7.91667 33.3412 7.75V6C35.5912 6.20833 37.7891 6.76042 39.9349 7.65625C42.0808 8.55208 44.112 9.75 46.0287 11.25L44.7787 12.5ZM53.0912 27.5C52.7995 25.125 52.2474 22.9896 51.4349 21.0938C50.6224 19.1979 49.5495 17.5 48.2162 16L49.4662 14.75C51.0079 16.5833 52.2266 18.5729 53.1224 20.7188C54.0183 22.8646 54.5912 25.125 54.8412 27.5H53.0912Z",
  fill: "white"
}));

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1554_1298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.360252f9.svg";
export { ForwardRef as ReactComponent };